import { create } from "../../../common/utils/zustand_state_manager";
import { RhService } from "../../../features/rh/data/services/rh_service_impl";
import { IRhService } from "../../../features/rh/data/services/rh_service";

/**
 * useRhServices
 */

type State = {
  rhService: IRhService,
};

export const useRhServices = create<State>((set, get) => ({
  rhService: new RhService(),
}));